import { put, takeEvery } from 'redux-saga/effects'
import { Game, Api } from '../../Core'
import * as actions from './documents.actions'

import DocumentsScreen from './DocumentsScreen'
import DocumentsButton from './DocumentsButton'

export function* loadComponents() {
  const components = {
    DocumentsScreen,
    DocumentsButton,
  }

  yield put(Game.actions.registerComponents(components))
}

export function* getDocuments() {
  try {
    let course = yield Api.get('/documents', {})
    const folders = course.map((c) => {
      return { ...c, type: c.isFolder ? 'folder' : null }
    })

    yield put(actions.setDocuments(folders))
    yield put(Game.actions.addScreen('documents_screen'))
  } catch (e) {
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* init() {
  yield loadComponents()
}

export function* sagas() {
  yield init()
  yield takeEvery(actions.LOAD_DATA, getDocuments)
}
